import { modules } from 'virtual:site-pages'

export const importPageModule=(id:string)=>Object.hasOwn(modules,id)
  ?modules[id]()
  :Promise.reject(new Error('Page module not found: '+id))
